import { render, staticRenderFns } from "./AdminOspitiIdView.vue?vue&type=template&id=793b77c0&"
import script from "./AdminOspitiIdView.vue?vue&type=script&lang=ts&"
export * from "./AdminOspitiIdView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports